import { FC, memo } from 'react';

import { DealConfigsProviderProps } from './types/DealConfigsProviderProps';
import { DealConfigsContext } from './DealConfigsContext';

const DealConfigsProviderComponent: FC<DealConfigsProviderProps> = ({
  children,
  value,
}) => (
  <DealConfigsContext.Provider value={value}>
    {children}
  </DealConfigsContext.Provider>
);

export const DealConfigsProvider = memo(DealConfigsProviderComponent);
